import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useModalContext } from '@dataswift/shared';

import { useHistory } from 'react-router';
import DevelopersPage from '../../styles/templates/DeveloperPage';
import { getApps } from '../../redux/applications/actions/AppActions';
import QuickStart from '../../components/QuickStart/QuickStart';
import ProjectList from '../../components/Projects/ProjectList';
import { selectProjects } from '../../redux/selectors/projects';
import { CreateAppModal } from '../../components/Modals';
import { ProjectListHeader } from '../../components/Projects/ProjectListHeader';
import { useUser, useDeveloperAccountModal } from '../../helpers/customHooks';
import { useThemeContext } from '../../styles/Provider';
import PageHeader from '../../styles/templates/PageHeader';

type DashboardPageProps = {
  path?: string;
  default?: boolean;
};

const DashboardPage: React.FC<DashboardPageProps> = () => {
  const dispatch = useDispatch();
  const projects = useSelector(selectProjects);
  const history = useHistory();
  const user = useUser();
  const { openModal, isOpen } = useModalContext();
  useDeveloperAccountModal();
  const { setTheme } = useThemeContext();

  useEffect(() => {
    const prefersLight = window.matchMedia?.('(prefers-color-scheme: light)').matches;
    if (prefersLight) setTheme('light');
  }, [setTheme]);

  useEffect(() => {
    dispatch(getApps());
  }, [dispatch]);

  const onDocsClick = () => history.push('/docs');

  const openCreateAppModal = () => {
    openModal({
      open: true,
      component: CreateAppModal,
      modalProps: {
        disableBackdropClick: true,
      },
    });
  };

  return (
    <DevelopersPage blurred={isOpen}>
      <PageHeader
        title={`Hello ${user?.username}`}
        subtitle="Welcome to your Developers Portal overview"
      />

      <QuickStart onQuickStart={openCreateAppModal} onDocsClick={onDocsClick} />

      <div>
        <ProjectListHeader />
        <ProjectList projects={projects || []} onNewProject={openCreateAppModal} />
      </div>
    </DevelopersPage>
  );
};

export default DashboardPage;
